import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

Vue.use(Router)

import Layout from '@/layout'


export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/login',
    children: [
      {
        path: '/login',
        component: () => import('@/views/login/index')
      },
      {
        path: '/index',
        component: () => import('@/views/index/index')
      },
      {
        path: '/aboutus',
        component: () => import('@/views/about/index')
      },
      {
        path: '/join',
        component: () => import('@/views/join/index')
      },
      {
        path: '/contact',
        component: () => import('@/views/contact/index')
      },
      {
        path: '/example/list',
        component: () => import('@/views/example/list')
      }
    ]
  },
  {
    path: '/study',
    meta: { title: '学习' },
    component: () => import('@/views/study/index')
  },
  {
    path: '/study/error',
    meta: { title: '错题练习' },
    component: () => import('@/views/study/error')
  },
  {
    path: '/person',
    component: Layout,
    redirect: '/person/index',
    children: [
      {
        path: '/person/index',
        meta: { title: '个人中心' },
        component: () => import('@/views/person/index')
      },
      {
        path: '/person/changepwd',
        meta: { title: '修改密码' },
        component: () => import('@/views/person/change_password')
      },
      {
        path: '/person/buyvip',
        meta: { title: '购买会员' },
        component: () => import('@/views/person/buy_vip')
      },
      {
        path: '/person/order',
        meta: { title: '我的订单' },
        component: () => import('@/views/person/order')
      }
    ]
  },
  {
    path: '/example',
    meta: { title: '模拟考试' },
    component: () => import('@/views/example/index')
  },
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

const whiteList = ['/login', '/aboutus', '/join', '/contact'] 

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  document.title = getPageTitle(to.meta.title)
  const hasToken = getToken()
  
  if (hasToken) {
    if (to.path === '/login') {
      // 已登录且访问登录页，重定向到首页
      next({ path: '/index' })
    } else {
      // 已登录且访问其他页面，继续导航
      next()
    }
  } else {
    // 未登录
    if (whiteList.indexOf(to.path) !== -1) {
      // 访问无需登录的页面，继续导航
      next()
    } else {
      // 访问需要登录的页面，重定向到登录页
      next(`/login?redirect=${to.path}`)
    }
  }

  NProgress.done()
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router
